import React from "react"
import InformationPage from "../components/information-page"
export default function AboutPage() {
  return (
    <InformationPage
      title="About School Calendar"
      description="Learn how School Calendar connects visual weekly planning with practical guides for families, teachers and students."
    >
      <p>
        School Calendar brings weekly planning and practical routines together.
        The <a href="https://app.schoolcalendar.me/">calendar app</a> lets you
        arrange events visually, draft events with Magic Generate, and publish a
        read-only calendar for others to follow.
      </p>
      <p>
        Articles are credited to schoolcalendar.me. This identifies the project
        responsible for the material, rather than a claim of specialist
        professional qualifications.
      </p>
      <h2>Who the guides are for</h2>
      <p>
        Our guides explore classroom schedules, family activities, practice
        routines and study skills. They offer worked examples that you can adapt
        to your commitments, interests and available time.
      </p>
      <h2>The website and the app</h2>
      <p>
        This website explains the product and provides planning ideas. The app
        is where you create and maintain calendars. Publishing creates a shared
        view; changing the original and updating that shared view are separate
        steps. See{" "}
        <a href="/how-to-guides/publish-share-calendar/">
          the publishing guide
        </a>{" "}
        for details.
      </p>
      <h2>Using the advice</h2>
      <p>
        Example schedules are illustrations, not personalised educational or
        health recommendations. Use relevant teacher or professional guidance
        when adapting a routine. Read{" "}
        <a href="/editorial-policy/">how our guides are prepared</a>, including
        their use of sources and AI assistance.
      </p>
      <p>
        Find the project on{" "}
        <a href="https://www.facebook.com/schoolcalendar">Facebook</a> and{" "}
        <a href="https://www.linkedin.com/company/school-calendar-me">
          LinkedIn
        </a>
        , or <a href="/guides/">explore the guides</a>.
      </p>
    </InformationPage>
  )
}
